import { useState } from 'react';
import BettieMissedNotePopup from './components/BettieMissedNotePopup';
import type { GetBettieProactiveMessagesResponse } from '@pocapan/shared/domains/bettie/services/bettieService';

type ProactiveMessage = GetBettieProactiveMessagesResponse['proactiveMessages'][number];
type PreviewScenario = 'default' | 'long';

const proactiveMessages: Record<PreviewScenario, ProactiveMessage> = {
  default: {
    proactiveMessageHistoryId: 1001,
    content: '오늘 하루 어땠어? 바빴을 것 같아서 먼저 말 남겨두고 갈게.',
    messageType: 'text',
    groupType: 'proactive',
    sentAt: new Date('2026-04-22T11:00:00+09:00').toISOString(),
    popupAction: null
  },
  long: {
    proactiveMessageHistoryId: 1002,
    content:
      '방금 네 생각이 나서 먼저 들렀어. 오늘 있었던 일 중에서 가장 기억에 남는 순간이 뭐였는지 궁금해. 괜찮으면 천천히 들려줘.',
    messageType: 'text',
    groupType: 'proactive',
    sentAt: new Date('2026-04-22T12:30:00+09:00').toISOString(),
    popupAction: null
  }
};

const BettieMissedNotePopupPreviewPage = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [scenario, setScenario] = useState<PreviewScenario>('default');
  const [lastAction, setLastAction] = useState('아직 눌러본 액션이 없어요.');

  const proactiveMessage = proactiveMessages[scenario];

  return (
    <div className="min-h-screen bg-[#f3efe8] px-[16px] py-[24px] text-text-main-lv1">
      <div className="mx-auto w-full max-w-[430px] overflow-hidden rounded-[32px] border border-black/5 bg-background-light shadow-[0_24px_80px_rgba(15,23,42,0.12)]">
        <div className="border-b border-black/5 bg-background-elevated px-[20px] pb-[16px] pt-[18px]">
          <p className="text-[18px] font-semibold leading-[24px]">BettieMissedNotePopup Preview</p>
          <p className="mt-[6px] text-[13px] leading-[18px] text-text-main-lv3">
            디자인 수정 전에 로컬에서 바로 상태를 바꿔보는 전용 화면이에요. 데스크톱에서는 브라우저
            반응형 모드로 보면 실제 모바일 폭에 더 가깝게 확인할 수 있어요.
          </p>
        </div>

        <div className="relative min-h-[860px] bg-[linear-gradient(180deg,#fffaf3_0%,#f7f1e7_100%)]">
          <div className="sticky top-0 z-10 flex h-[72px] items-center justify-between border-b border-black/5 bg-background-light/95 px-[20px] backdrop-blur">
            <button
              type="button"
              className="text-[14px] font-medium text-text-main-lv2"
              onClick={() => window.history.back()}
            >
              뒤로
            </button>
            <p className="text-[16px] font-semibold leading-[20px]">Bettie</p>
            <span className="text-[13px] text-text-main-lv3">미리보기</span>
          </div>

          <div className="px-[16px] pb-[48px] pt-[260px]">
            <div className="rounded-[24px] bg-white/72 p-[16px] shadow-[0_8px_30px_rgba(15,23,42,0.06)] backdrop-blur">
              <p className="text-[13px] font-semibold leading-[18px] text-text-main-lv2">
                Preview Controls
              </p>
              <div className="mt-[12px] grid grid-cols-2 gap-[8px]">
                <button
                  type="button"
                  className={`rounded-[14px] px-[12px] py-[10px] text-[13px] font-semibold ${
                    scenario === 'default' ? 'bg-black text-white' : 'bg-white text-text-main-lv2'
                  }`}
                  onClick={() => setScenario('default')}
                >
                  기본 문구
                </button>
                <button
                  type="button"
                  className={`rounded-[14px] px-[12px] py-[10px] text-[13px] font-semibold ${
                    scenario === 'long' ? 'bg-black text-white' : 'bg-white text-text-main-lv2'
                  }`}
                  onClick={() => setScenario('long')}
                >
                  긴 문구
                </button>
                <button
                  type="button"
                  className={`rounded-[14px] px-[12px] py-[10px] text-[13px] font-semibold ${
                    isOpen ? 'bg-[#e8f3ea] text-[#23613a]' : 'bg-white text-text-main-lv2'
                  }`}
                  onClick={() => setIsOpen((previous) => !previous)}
                >
                  {isOpen ? '팝업 숨기기' : '팝업 열기'}
                </button>
                <button
                  type="button"
                  className={`rounded-[14px] px-[12px] py-[10px] text-[13px] font-semibold ${
                    isDisabled ? 'bg-[#fff0df] text-[#8a5600]' : 'bg-white text-text-main-lv2'
                  }`}
                  onClick={() => setIsDisabled((previous) => !previous)}
                >
                  {isDisabled ? '답장 가능' : '답장 막기'}
                </button>
                <button
                  type="button"
                  className={`col-span-2 rounded-[14px] px-[12px] py-[10px] text-[13px] font-semibold ${
                    isSubmitting ? 'bg-[#eef2ff] text-[#3f51b5]' : 'bg-white text-text-main-lv2'
                  }`}
                  onClick={() => setIsSubmitting((previous) => !previous)}
                >
                  {isSubmitting ? '전송 상태 끄기' : '전송 상태 켜기'}
                </button>
              </div>
            </div>

            <div className="mt-[16px] space-y-[12px]">
              <div className="ml-auto max-w-[220px] rounded-[20px] rounded-br-[8px] bg-[#2d2f39] px-[14px] py-[12px] text-[14px] leading-[19px] text-white shadow-[0_8px_20px_rgba(15,23,42,0.12)]">
                일 끝나고 확인할게. 오늘은 좀 정신이 없었어.
              </div>
              <div className="max-w-[250px] rounded-[20px] rounded-bl-[8px] bg-white px-[14px] py-[12px] text-[14px] leading-[19px] text-text-main-lv1 shadow-[0_8px_20px_rgba(15,23,42,0.08)]">
                괜찮아. 대신 나중에라도 답장해주면 기다리고 있을게.
              </div>
            </div>

            <div className="mt-[20px] rounded-[24px] border border-black/5 bg-white/80 p-[16px] shadow-[0_8px_30px_rgba(15,23,42,0.06)]">
              <p className="text-[13px] font-semibold leading-[18px] text-text-main-lv2">
                Last action
              </p>
              <p className="mt-[6px] text-[14px] leading-[20px] text-text-main-lv1">{lastAction}</p>
            </div>
          </div>

          {isOpen ? (
            <BettieMissedNotePopup
              nickname="원희"
              proactiveMessage={proactiveMessage}
              disabled={isDisabled}
              isOutOfPoints={isDisabled}
              isSubmitting={isSubmitting}
              position="absolute"
              onReply={(content) => {
                setLastAction(`답장 전송: ${content}`);
              }}
              onLater={() => {
                setLastAction('나중에 보기 클릭');
              }}
              onDislike={() => {
                setLastAction('이런 메시지는 제 취향이 아니에요 클릭');
              }}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default BettieMissedNotePopupPreviewPage;
